import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { LoadingWidget } from '../../../../widgets';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allEntidadesAction } from '../EntidadesAction';

const SelectFieldEntidadesComponent = ({
  onChange,
  data,
  value,
  selects = [],
  required = false,
  notSuscripcion = false,
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data) {
        await allEntidadesAction(dispatch);
        setItems(entidadesStore.all);
      }

      if (entidadesStore.all.length > 0 && notSuscripcion) {
        const list = entidadesStore.all.filter(
          (el) => el.suscripciones.length === 0,
        );
        setItems(list);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      entidadesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id={`label_${CONST.entidad.name}`}>
        {CONST.entidad.label}
      </InputLabel>
      <Select
        id={CONST.entidad.name}
        value={value}
        labelId={`label_${CONST.entidad.name}`}
        label={CONST.entidad.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {items.map((el, index) => {
          return (
            <MenuItem key={`entidad-${index}`} value={el.id}>
              {el.nombre.toUpperCase()}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-entidades"
      opt={items}
      type={CONST.entidad.name}
      value={value}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l={CONST.entidad.label}
    />
  );

  return entidadesStore.loadingAll ? (
    <LoadingWidget isLoading={entidadesStore.loadingAll} />
  ) : isAutoComplete ? (
    autoComplete
  ) : (
    select
  );
};

export default SelectFieldEntidadesComponent;
